import Image from 'assets/img/no-image.svg';

export { default as NoImage } from 'assets/img/no-image.svg';

export const handleNoImage = (e: React.BaseSyntheticEvent) => {
  e.target.onerror = null;
  e.target.src = Image;
};
